import { Heart, Lovely, EmojiHappy, MedalStar, UserOctagon, People, Profile2User, BackSquare } from "iconsax-react";
import type { Icon } from "iconsax-react";

interface SocialCategoryIconConfig {
  Icon: Icon;
  colorClass: string;
}

const SOCIAL_CATEGORY_ICON_MAP: Record<string, SocialCategoryIconConfig> = {
  disability_1: { Icon: Heart, colorClass: "viz-categorical-06-text" },
  disability_2: { Icon: Lovely, colorClass: "viz-categorical-06-text" },
  child_disability: { Icon: EmojiHappy, colorClass: "viz-categorical-06-text" },
  veteran: { Icon: MedalStar, colorClass: "content-action-negative" },
  orphan: { Icon: UserOctagon, colorClass: "viz-categorical-05-text" },
  large_family: { Icon: People, colorClass: "viz-categorical-05-text" },
  single_parent_family: { Icon: Profile2User, colorClass: "viz-categorical-05-text" },
  kandas: { Icon: BackSquare, colorClass: "viz-categorical-03-text" },
};

export function getSocialCategoryIconConfig(categoryType: string): SocialCategoryIconConfig | null {
  return SOCIAL_CATEGORY_ICON_MAP[categoryType] ?? null;
}

export { SOCIAL_CATEGORY_ICON_MAP };
export type { SocialCategoryIconConfig };
